export { default } from 'common/models/og-image';
